/* src/app/components/my-loader/my-loader.component.scss */
.loading-spinner img {
  align-self: end;
}
.loading-message {
  text-align: center;
  align-self: start;
}
.loading-spinner {
  position: fixed;
  z-index: 1001;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
}
.loading-spinner:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
/*# sourceMappingURL=my-loader.component.css.map */
